function Table({ tableChillingData }) {

    return (

        <div className="flex flex-col justify-center items-center mt-5">

            <div className="flex flex-row justify-center items-center h-full w-full">
                <div className="w-[200px] text-center text-president font-bold text-[16px] !font-[B-Nazanin] rounded-tr-[5px]" style={{ borderTop: '1.5px solid black', borderRight: '1.5px solid black', borderBottom: '0.75px solid black', borderLeft: '0.75px solid black', backgroundColor: 'rgba(70, 15, 129, 0.20)' }}>
                    رقم
                </div>
                <div className="w-[280px] text-center text-president text-[16px] rounded-tl-[5px] font-bold !font-[B-Nazanin]" style={{ borderTop: '1.5px solid black', borderRight: '0.75px solid black', borderBottom: '0.75px solid black', borderLeft: '0.75px solid black', backgroundColor: 'rgba(70, 15, 129, 0.20)' }}>
                    وضعیت
                </div>
            </div>
        
            {
                tableChillingData?.map((cultivar, i) => {
                    return (
                        <div key={i} className="flex flex-row justify-center items-center w-full">
                            <div className={`w-[200px] text-center text-[#333] ${tableChillingData?.length - 1 === i && 'rounded-br-[5px]'} text-[16px] font-bold !font-[B-Nazanin]`} style={{ borderTop: '0.75px solid black', borderRight: '1.5px solid black', borderBottom: '0.75px solid black', borderLeft: '0.75px solid black' }}>
                                {cultivar?.name}
                            </div>
                            <div dir='ltr' className={`flex flex-row items-center justify-between w-[280px] px-2 text-center text-[#333] text-[16px] font-bold ${tableChillingData?.length - 1 === i && 'rounded-bl-[5px]'} !font-[B-Nazanin]`} style={{ borderTop: '0.75px solid black', borderRight: '0.75px solid black', borderBottom: '0.75px solid black', borderLeft: '0.75px solid black' }}>
                                <div className={`Ellipse41 w-3 h-3 ${!cultivar?.passed ? 'bg-red-500' : 'bg-green-500'} rounded-full shadow`} />
                                {!cultivar?.passed ? 'نیاز سرمایی تامین نشده است ' : 'نیاز سرمایی تامین شده است '}
                            </div>
                        </div>
                    )
                })
            }

        </div>
    )
}

export default Table